<ng-content select="[slot='header']" />

@if (enableScroll) {
    <div #scrollWrapper class="flex-grow-1 overflow-y">
        <ng-container *ngTemplateOutlet="contentRef" />
    </div>
} @else {
    <ng-container *ngTemplateOutlet="contentRef" />
}

<ng-template #contentRef>
    <ng-content select="[slot='content']" />
</ng-template>
